import AdminBadge from '@assets/icons/admin-badge.svg'
import { Icon } from './Icon'

export const AdminBadgeIcon = Icon(AdminBadge)
